<template>
  <div class="w-full flex flex-col">
    <HelpChatPanel />
  </div>
</template>

<script setup>
import { useRouter } from 'vue-router';
import HelpChatPanel from './HelpChatPanel.vue';

</script>
